/**
 * Created by slava on 25/10/17
 *
 * To regenerate font PNGs from TTF/OTF sources:
 *   python3 cleverapps/src/uicomponents/components/generate_imagefont.py <config.json>
 */

cleverapps.UI.ImageFont = cc.Node.extend({
    ctor: function (string, font, params) {
        this._super();
        this.params = params || {};

        this.letters = new cc.Node();
        this.letters.setAnchorPoint(0, 0);
        this.letters.setCascadeOpacityEnabled(true);
        this.letters.setCascadeColorEnabled(true);
        this.addChild(this.letters);

        this.setFont(font);

        this.setAnchorPoint(0.5, 0.5);
        this.setCascadeOpacityEnabled(true);

        this.setString(string);

        this.setCascadeColorEnabled(true);
    },

    setHorizontalAlignment: function () {
    },

    setVerticalAlignment: function () {
    },

    setDimensions: function (width, height) {
        if (height === undefined && width.width) {
            height = width.height;
            width = width.width;
        }

        if (!(width > 0)) {
            width = 0;
        }

        if (!(height > 0)) {
            height = 0;
        }

        if (!cc.sizeEqualToSize(this.dimensions, cc.size(width, height))) {
            this.dimensions = cc.size(width, height);
            this.fitTo(width, height);
        }
    },

    getDimensions: function () {
        return this.dimensions || cc.size(0, 0);
    },

    fitTo: function (maxWidth, maxHeight) {
        this.setFontSize(this._originalFontSize);

        let i = 0;
        while (i < 10) {
            const width = this.width;
            const height = this.height;
            const canAttachLastLine = this.canAttachLastLine();
            if (maxWidth && width > maxWidth || maxHeight && height > maxHeight || canAttachLastLine) {
                i++;

                let scaleX = 1;
                let scaleY = 1;
                if (maxWidth && width > maxWidth) {
                    scaleX = maxWidth / width;
                }

                if (maxHeight && height > maxHeight) {
                    scaleY = maxHeight / height;
                }

                let scale = 0.9;
                const minScale = Math.min(scaleX, scaleY);
                if (minScale > 0.9 && minScale < 1) {
                    scale = minScale;
                }

                this.setFontSize(Math.floor(this.getFontSize() * scale));
            } else {
                break;
            }

            if (this.getFontSize() < cleverapps.UI.ImageFont.getFontSizeThreshold()) {
                this.setFontSize(cleverapps.UI.ImageFont.getFontSizeThreshold());
                return;
            }
        }
    },

    countToAnimation: function (time, amount) {
        this.runAction(StandartAnimations.countTo(this, amount, {
            duration: time
        }));
    },

    canAttachLastLine: function () {
        return false;
    },

    setFont: function (font) {
        const lookUp = font.name ? font.name : "default";

        const options = cleverapps.UI.ImageFont.listFonts().filter((imageFont) => imageFont.name === lookUp).sort((imageFontA, imageFontB) => {
            const scaleA = Math.abs(1 - font.size / imageFontA.size);
            const scaleB = Math.abs(1 - font.size / imageFontB.size);

            return scaleA - scaleB;
        });

        const selectedFont = options[0];
        if (selectedFont === undefined) {
            console.log(font);
            throw "No image font";
        }

        this.font = font;
        this.baseFont = selectedFont;

        this.bundle = selectedFont.bundle;
        this.prefix = `${selectedFont.name + selectedFont.originalSize}pt_`;

        this.strokeSize = font.stroke ? font.stroke.size : 0;
        this.shadowOffset = font.shadow ? cc.size(font.shadow.direction.width || font.shadow.direction.x || 0, font.shadow.direction.height || font.shadow.direction.y || 0) : cc.size(0, 0);

        this.setFontSize(font.size);
        this._originalFontSize = font.size;

        const string = this.originalString;
        if (string !== undefined) {
            this.setString(string);
        }
    },

    setString: function (text) {
        this.originalString = text;

        this._setString(text);
    },

    _setString: function (string) {
        if (this.stopListeners) {
            return;
        }

        this.string = `${typeof string === "number" ? string : string || ""}`;

        if (this.letters.getChildrenCount() !== this.string.length) {
            this.letters.removeAllChildren(true);
        }

        const isDigit = function (char) {
            return char !== undefined && char.charCodeAt(0) >= "0".charCodeAt(0) && char.charCodeAt(0) <= "9".charCodeAt(0);
        };

        const styles = cleverapps.styles.UI.ImageFont;

        let decimalPointIndex = undefined;

        const totalSize = cc.size(0, 0);
        this.string.split("").forEach(function (letter, index, letters) {
            if (isDigit(letter)) {
                if (decimalPointIndex === undefined) {
                    if (letters[index - 1] === ".") {
                        decimalPointIndex = index - 1;
                    } else {
                        for (let i = index; i < letters.length && isDigit(letters[i]); ++i) {
                            decimalPointIndex = i + 1;
                        }
                    }
                }
            } else {
                decimalPointIndex = undefined;
            }

            if (decimalPointIndex !== undefined) {
                const toDecimalPoint = decimalPointIndex > index ? decimalPointIndex - index : index - decimalPointIndex - 1;
                if (toDecimalPoint % 3 === 0 && isDigit(letters[index - 1])) {
                    totalSize.width += styles.thousandsOffset * this.baseFont.size / styles.thousandsFontSize;
                }
            }

            this.createLetter(letter, totalSize, index);
            this.setLetterColor(index, this.font.color || cleverapps.styles.COLORS.WHITE);
        }, this);

        this.letters.setContentSize2(totalSize);

        this.setFontSize(this.getFontSize());

        if (this.dimensions) {
            this.fitTo(this.dimensions.width, this.dimensions.height);
        }
    },

    setLetterColor: function (index, color) {
        const letter = this.letters.getChildren()[index];
        if (!letter) {
            console.warn("No letter at index: ", index);
            return;
        }

        letter.setColor(color);
    },

    createLetter: function (letter, totalSize, index) {
        let offset = this.baseFont.lettersOffset;
        if (index === 0) {
            offset = 0;
        }

        if (cleverapps.UI.ImageFont.LETTERS_MAP[letter]) {
            letter = cleverapps.UI.ImageFont.LETTERS_MAP[letter];
        }

        const image = bundles[this.bundle].frames[this.prefix + letter];
        if (!image) {
            console.log(this);
            console.log("No image for letter: ", letter);
            cleverapps.throwAsync(`No image for letter: ${letter}, bundle - ${this.bundle}, prefix - ${this.prefix}`);
        }

        let sprite;

        if (this.letters.getChildrenCount() <= index) {
            sprite = new cc.Sprite(image);
            this.letters.addChild(sprite);
        } else {
            sprite = this.letters.getChildren()[index];
            if (image) {
                sprite.setSpriteFrame(image);
            }
        }

        let width = 2 * Math.round(sprite.width / 2);
        if (this.params.fixedNumberWidth && letter >= "0" && letter <= "9") {
            if (!this.baseFont.zeroLetterWidth) {
                const zeroWidth = new cc.Sprite(bundles[this.bundle].frames[`${this.prefix}0`]).width;
                this.baseFont.zeroLetterWidth = 2 * Math.round(zeroWidth / 2);
            }

            width = this.baseFont.zeroLetterWidth;
        }

        sprite.setAnchorPoint(0.5, 0);
        sprite.setAlignment(totalSize.width + width / 2 + offset, 0);

        totalSize.width += width + offset;
        totalSize.height = Math.max(totalSize.height, sprite.height);
    },

    getString: function () {
        return this.string;
    },

    getFontSize: function () {
        return Math.floor(this.letters.scale * this.baseFont.size);
    },

    setFontSize: function (size) {
        const properties = this.properties = cc.LabelTTF.__getFontProperties(cleverapps.UI.getFontName(this.font.font), size);
        const scale = size / this.baseFont.size;

        this.letters.setScale(scale);
        this.letters.setPosition(0, properties.descent - Math.ceil(size * this.baseFont.descent) + this.strokeSize + Math.abs(this.shadowOffset.height));

        this.setContentSize2(this.letters.width * this.letters.scale, properties.ascent + properties.descent + this.strokeSize * 2 + Math.abs(this.shadowOffset.height) * 2);
    }
});

cleverapps.UI.ImageFont.MAX_MAGNITUDE = 1.25;

cleverapps.UI.ImageFont.LETTERS_MAP = {
    "/": "slash",
    "+": "plus",
    "-": "minus",
    ":": "colon",
    "#": "sharp",
    ".": "point",
    " ": "space",
    "[": "left_square_bracket",
    "]": "right_square_bracket",
    "*": "asterisk",
    "%": "percent"
};

cleverapps.UI.ImageFont.listFonts = function () {
    if (this.fontsCache) {
        return this.fontsCache;
    }

    this.fontsCache = [];

    Object.keys(bundles).forEach((bundleName) => {
        const bundle = bundles[bundleName];
        const font = bundle.meta.font;
        if (font) {
            const fontKey = font.folder.replace(/\/?\d+pt\/?/, "");
            this.fontsCache.push({
                bundle: bundleName,
                name: font.name,
                size: font.size,
                originalSize: font.size,
                descent: cleverapps.styles.UI.ImageFont.SKIP_RESOLUTION.DESCENTS[fontKey] || 0,
                lettersOffset: cleverapps.styles.UI.ImageFont.lettersOffset[fontKey] || cleverapps.styles.UI.ImageFont.lettersOffset.default
            });
        }
    });

    return this.fontsCache;
};

cleverapps.UI.ImageFont.getFontSizeThreshold = function () {
    let threshold = 8;
    if (!connector.info.isMobile) {
        threshold = 5;
    }
    return threshold * resolutionScale;
};

cleverapps.UI.ImageFont.IsApplicable = function (font, text) {
    text = `${typeof text === "number" ? text : text || ""}`;

    if (!text) {
        return true;
    }

    const lookUp = font.name ? font.name : "default";

    const fonts = cleverapps.UI.ImageFont.listFonts();

    let bundle, prefix, i;
    for (i = 0; i < fonts.length; i++) {
        const imageFont = fonts[i];

        if (imageFont.name === lookUp) {
            const isLoaded = cleverapps.bundleLoader.isLoaded(imageFont.bundle);

            if (isLoaded) {
                bundle = imageFont.bundle;
                prefix = `${imageFont.name + imageFont.originalSize}pt_`;
            }
        }
    }

    if (!bundle) {
        return false;
    }

    for (i = 0; i < text.length; i++) {
        const code = cleverapps.UI.ImageFont.LETTERS_MAP[text[i]] || text[i];
        if (!bundles[bundle].frames[prefix + code]) {
            return false;
        }
    }

    return true;
};

cleverapps.UI.ImageFont.intertypeSetString = function (params) {
    const isImage = params.textObj instanceof cleverapps.UI.ImageFont;
    const canImage = cleverapps.UI.ImageFont.IsApplicable(params.font, params.string);

    if (isImage === canImage) {
        params.textObj.setString(params.string);
    } else {
        params.recreateFunc(params.string);
    }
};

cleverapps.styles.UI.ImageFont = {
    SKIP_RESOLUTION: {
        DESCENTS: {
            "fonts/formal": 0,
            "fonts/custom/custom_digits": 0.15,
            "fonts/custom/heroes_custom_digits": 0
        }
    },

    lettersOffset: {
        default: -4
    },

    thousandsOffset: 6,
    thousandsFontSize: 41
};
